'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = exports.CellType = undefined;

var _style = require('./style');

const CellType = exports.CellType = {
  TypeString: 49,
  TypeFormula: 0,
  TypeNumeric: 1,
  TypeBool: 0,
  TypeInline: 0,
  TypeError: 0,
  TypeDate: 14,
  TypeGeneral: 0
};

let Cell = exports.Cell = class Cell {

  constructor(_ref) {
    let row = _ref.row;
    this.value = '';
    this.formula = '';
    this.numFmt = '';
    this.date1904 = false;
    this.hidden = false;
    this.hMerge = 0;
    this.vMerge = 0;
    this._style = null;
    this.cellType = 'TypeString';

    this.row = row;
  }
  get style() {
    if (this._style === null) {
      this._style = new _style.Style();
    }
    return this._style;
  }
  set style(s) {
    this._style = s;
  }
};